import { Navigate } from "react-router-dom"
import { useLocation } from "react-router-dom";
import Swal from 'sweetalert2'
const RequireAuth = ({ children, userroles }) => {
    let currentUserRole;
    if (localStorage.getItem("user")) {
        currentUserRole = localStorage.getItem("role");
    }
    const location = useLocation();
    if (currentUserRole) {
        if (userroles) {
            //console.log(currentUserRole)
            if (userroles.includes(currentUserRole)) {
                return children
            } else if (currentUserRole === "guest") {
                Swal.fire('You are currently identify as a Guest. ', "You will see a empty page since guest do not have assess to any other thing. Contact Office for more detail.", 'warning')
                return <Navigate to="/HomePage" />
            } else {
                Swal.fire('Access Denied !', "", 'warning')
                return <Navigate to="/HomePage" />
            }
        } else {
            return children
        }
    } else {
        return <Navigate to="/login" state={{ path: location.pathname }} />
    }
}
export default RequireAuth